import { useCallback, useEffect, useState } from 'react';
import { Carousel } from 'antd';
import { ImageReloader } from '../image-reloader';

// services
import * as DashboardService from '../../../../services/bb-api/dashboards';

export function UserStories(props: any): JSX.Element {
	const [storyData, setStoryData] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(true);

	const callbackUserStoriesQuery: () => Promise<void> = useCallback(userStoriesQuery, [props]);

	// userStoriesQuery is run on first render of page
	useEffect(() => {
		setLoading(true);
		callbackUserStoriesQuery();
	}, [callbackUserStoriesQuery]);

	// useEffect to run userStoriesQuery method once every minute and will also unmount
	useEffect(() => {
		const interval: NodeJS.Timeout = setInterval(async () => {
			await callbackUserStoriesQuery();
		}, 60_000);

		return () => clearInterval(interval);
	}, [callbackUserStoriesQuery]);

	async function userStoriesQuery() {
		try {
			const stories = await DashboardService.queryUserStories();
			stories.forEach((story: any) => {
				story.title = story.title.replace('–', '-')
				story.name = story.title.substr(0, story.title.indexOf(' - '))
				story.title = story.title.substr(story.title.indexOf(' - '), story.title.length - 1)
			})
			setStoryData(stories);
		} catch (error) {
			props.handleShowError();
		}
		setLoading(false);
	}

	return (
		<div className="user-story-panel">
			{!loading && (
				<Carousel autoplay autoplaySpeed={20000} effect="fade" dots={false}>
					{storyData.map((item: any) => (
						<div key={item.id}>
							<div className="carousel-container">
								<div className="carousel-img-container">
									<ImageReloader className="carousel-img-reload" src={item.img_path} />
								</div>
								<div className="carousel-text-container">
									<div className="carousel-titel">
										<h1><span className="username">{item.name}</span>{item.title}</h1>
									</div>
									<div className="carousel-text">
										<p>{item.teaser}</p>
									</div>
								</div>
							</div>
						</div>
					))}
				</Carousel>
			)}
		</div>
	);
}
